export default __webpack_public_path__ + "static/media/3000.fe0ae0ea.jpg";